(function() {
    /** @ngInject */
    function confirmPageController($scope, $state){
        $scope.show_terms = false;
        $scope.next = function(){
            if(!$scope.booking.hasErrors()){
                $scope.booking.save().success(function(response){
                    if(response.success !== true || !_.has(response, 'booking')){
                        alert(response.errors);
                        return false;
                    }
                    if(typeof(window.top) !== 'undefined')
                        window.top.postMessage('scrollTop', "*");
                    if(response.booking && response.booking.id > 0) {
                        $scope.booking.initFromDbObj(response.booking);
                        $scope.date = $scope.booking.getDate('YYYY-MM-DD');
                        if(response.booking.status === 0) {
                            $state.go('payinwidget', {}, {location: false});
                        }else{
                            window.parent.postMessage("reservationSuccess", "*");

                            /*if(settings.is_bb_ref === true && window.self === window.top){
                                window.location = 'https://www.bokabord.se/thankyou';
                                return;
                            }*/
                            //window.setTimeout(function() {
                            window.location = '/reservation/booking/?code=' + response.booking.short_code + '&new=1';
                            return;
                            //},2000);
                        }
                    }
                });
                $scope.$on("$viewContentLoaded", function() {
                    updateWidgetStep('Confirm');
                    setSyncProducts();
                });
            }
        };
        $scope.back = function(){
            $state.go('time', {}, {location : false});
        };
        $scope.getProductsList = function(){
            var hiddenProducts = [];
            if($scope.booking.booking_products.length > 0){
                var sync_products = _.filter($scope.booking.booking_products, {sync_child : 1});
                if(sync_products){
                    _.forEach(sync_products, function(pProduct, pIndex){
                        hiddenProducts = hiddenProducts.concat(pProduct.pairing);
                    });
                }
            }
            return _.filter($scope.booking.booking_products, function(p){
                return !_.includes(hiddenProducts,p.ID);
            });
        }



    }
    angular.module("Waiteraid").controller("confirmCtrl", confirmPageController);
})();
